// The Radar: the stage, its layers, the card of a topic, an audience, an
// event; and what opens from it (an audience's personas, a listening, the
// moment you talk to a persona, the card of a V2 persona).
export default {
  sousTitre: 'Your {n} observed territories: what is rising among them, what is coming up',
  chargement: 'Loading the radar…',
  erreurLecture: 'The radar could not be loaded.',
  aucunTerritoire: 'No territories are open to your account yet.',
  aucunTerritoireSuite: 'As soon as an administrator opens one, it will appear here.',
  calques: {
    aria: 'Layers',
    chaines: 'Channels',
    vod: 'VOD and streaming',
    sociales: 'Social platforms',
    verticales: 'Verticals',
    jeunes: 'Young audiences',
    politique: 'Politics',
  },
  recoupements: {
    bouton: 'Audience overlaps',
    aria: 'Overlaps measured by',
    parSujets: 'by topic',
    parPersonas: 'by persona',
    enCommun: 'in common',
    legendePersonas: 'two audiences sharing the same personas',
    legendeSujets: 'two audiences talking about the same topics',
  },
  vue: {
    aria: 'View',
    publics: 'Audiences',
    pays: 'Countries · {n}',
  },
  scene: {
    aria: 'Radar',
    voirCarte: '{pays}: see the country map',
    paysDe: 'home country of',
    vosPublics: 'your audiences',
    puceSujetsNeufs: '{nom}, {n} new topics',
    retirerSelection: 'Clear selection',
    publicsObserves: '{n} audiences observed | {n} audience observed | {n} audiences observed',
    sujetsMontent: '{n} topics rising among them | {n} topic rising among them | {n} topics rising among them',
    rienNeMonte: 'nothing is rising among them yet',
    pastillePublics: '{n} audiences | {n} audience | {n} audiences',
    legendeSujetsNeufs: 'new topics among this audience',
    legendeBientot: 'observation starting soon',
    legendeCombien: 'how many new topics',
    legendeFormat: 'their audience is talking about one of your formats',
  },
  carte: {
    aria: 'Your countries',
    enOrbite: '{n} audiences in orbit · back to audiences',
    vosPays: 'Your {n} countries | Your country | Your {n} countries',
  },
  liste: {
    monteDansPays: 'Rising in your countries',
    monteAupresPublics: 'Rising among your audiences',
    politique: 'political',
    publics: '{n} audiences | {n} audience | {n} audiences',
    jours: '{n} days | {n} day | {n} days',
    rien: 'Nothing is surfacing among these audiences yet.',
    aVenirPays: 'Coming up in your countries',
    aVenirPublics: 'Coming up for your audiences',
  },
  votreFormat: 'your format',
  votreFormatChez: 'your format · {chaine}',
  votreFormatTitre: 'your format: {titre}',
  tousLesSujets: 'All topics',
  ficheSeLit: 'Loading…',
  evenement: {
    types: {
      audience: 'Audience',
      frequentation: 'Attendance',
      achat: 'Purchase',
      pratique: 'Participation',
      opinion: 'Opinion',
      vote: 'Vote',
      autre: 'Projection',
    },
    question: '‘{question}’',
    le: ', on {jour}',
    detail: 'Breakdown',
    bandeAges: '{de}-{a}',
    bandeAgesPlus: '{de}+',
    genres: {
      Femmes: 'Women',
      Hommes: 'Men',
    },
    sansPanel: 'Nothing to ask a population about this event.',
    sansPanelRaison: 'Nothing to ask a population about this event: {raison}',
    panelRepond: 'The {nom} audience panel is answering.',
    projectionSePrepare: 'The projection is being prepared.',
    avecStimulus: 'With ‘{titre}’',
    votreStimulus: 'your stimulus',
    effetStimulus: '{pts} with the stimulus',
    stimulusEchec: 'The panel could not view this stimulus: try an image or a text.',
    panelRegarde: 'The panel is watching before answering.',
    etudeSePrepare: 'The study is being prepared and will launch within the hour.',
    simulation: 'The simulation',
    bornesScenarios: '{bas}% ~ {haut}%',
    bornesDeA: 'from {bas} to {haut}%',
  },
  approfondir: {
    ouvrir: 'Go deeper with a visual, a video or a text',
    choisirFichier: 'Choose a file',
    ariaForme: 'What to show',
    formes: {
      image: 'Image',
      video: 'Video',
      texte: 'Text',
    },
    adresseImage: 'or an image URL',
    adresseVideo: 'or a video URL (YouTube included)',
    textePlaceholder: 'The text the panel will read: a pitch, a tagline, a press release',
    nomPlaceholder: 'Its name (for your reference)',
    jumeaux: 'Twins',
    envoi: 'Sending…',
    lancer: 'Launch the deep dive',
    annuler: 'Cancel',
    erreurTexte: 'Write the text the panel will read.',
    erreurImage: 'Upload an image or paste its URL.',
    erreurVideo: 'Upload a video or paste its URL (YouTube included).',
    erreurEnvoi: 'The deep dive could not be launched.',
    titreVisuel: 'Visual',
    titreVideo: 'Video',
  },
  sujet: {
    publics: '{n} of your audiences',
    joursAffilee: '{n} days in a row',
    mentions: '{n} mentions | {n} mention | {n} mentions',
    mentionsChez: '{mentions} across {n} of your audiences',
    mentionsDuAu: '{mentions} across {n} of your audiences, from {du} to {au}',
    ouRessort: 'Audiences where it stands out most',
    quiEnParle: 'Who is talking about it:',
    ageMedian: 'median age {n}',
    sentimentTerritoires: 'Sentiment across territories',
    sentimentTerritoire: 'Territory sentiment',
    etAutres: '{noms} and {n} others | {noms} and {n} other | {noms} and {n} others',
    etDernier: '{noms} and {dernier}',
    favorables: 'favourable',
    neutres: 'neutral',
    defavorables: 'unfavourable',
    polariteAria: '{f}% favourable, {m}% neutral, {d}% unfavourable',
    sansAvis: 'Nobody holds a clear-cut view yet: people talk about it, neither for nor against.',
    sentimentSeLit: 'Reading the sentiment.',
    sentimentGlobal: 'Overall sentiment',
    origineEnLigne: 'people talking about ‘{sujet}’ online',
    sansAvisEnLigne: 'Nobody holds a clear-cut view on it online yet.',
    ceQueCest: 'What it is',
    publie: 'Published:',
    selon: '{valeur} according to {source}',
    projete: 'projected {x}',
    sesPersonas: 'Its personas',
    explorer: 'Explorer',
    poserQuestion: 'Ask the panel',
  },
  public: {
    familles: {
      france: 'Country',
      pays: 'Country',
      ville: 'City',
      region: 'Region',
      chaine: 'Channel',
      vod: 'VOD and streaming',
      sociale: 'Social platform',
      plateforme: 'Platform',
      jeunes: 'Young audience',
      thematique: 'Thematic audience',
      politique: 'Political territory',
    },
    groupes: {
      tf1: 'TF1 group',
      ftv: 'France Télévisions',
      m6: 'M6 group',
      canal: 'Canal+ group',
      arte: 'Arte',
      amaury: 'Amaury group',
      rmcbfm: 'RMC BFM',
      lcp: 'parliamentary channels',
    },
    familleChaine: 'Channel · {groupe}',
    familleStreaming: 'Streaming · {groupe}',
    bientotObserve: 'Observation starting soon',
    observe: 'Observed',
    observeSujets: 'Observed · {n} new topics | Observed · {n} new topic | Observed · {n} new topics',
    partAudience: 'Audience share, {mois}',
    quiLeRegarde: 'Who watches it',
    origine: 'the {nom} audience',
    questions: {
      regardes: 'What do you watch on {nom}?',
      zapper: 'What would make you switch over?',
      manque: 'What do you feel is missing from TV right now?',
    },
    monte: 'Rising among its audience',
    premiersSujets: 'Its first topics are coming soon.',
    recoupe: 'Its audience overlaps with',
    createurs: 'Its go-to creators',
    ficheDiffuseur: 'Broadcaster page',
    tester: 'Test a format',
  },
  mouvement: {
    installe: 'Settling in',
    monte: 'Rising',
    nouveau: 'New',
  },
  nombre: {
    pc: '{v}%',
    points: '{v} pts',
  },
  deuxPoints: '{x}:',
  guillemets: '‘{x}’',
  personas: {
    erreur: 'The personas could not be loaded.',
    seDessinent: 'The personas are taking shape…',
    sources: {
      territoire: 'Built from Orion’s intelligence, including {n} studies and sources. | Built from Orion’s intelligence, including {n} study or source. | Built from Orion’s intelligence, including {n} studies and sources.',
      panel: 'Built from the panel’s answers and Orion’s intelligence, including {n} studies and sources on its audiences. | Built from the panel’s answers and Orion’s intelligence, including {n} study or source on its audiences. | Built from the panel’s answers and Orion’s intelligence, including {n} studies and sources on its audiences.',
      ecoute: 'Built from Orion’s intelligence, including {n} posts collected online. | Built from Orion’s intelligence, including {n} post collected online. | Built from Orion’s intelligence, including {n} posts collected online.',
    },
    voirFiche: 'View {prenom}’s profile',
    suitAussiPublic: 'Its audience also follows',
    titreFiche: 'Persona · {prenom}',
    duPublic: '{part}% of the audience',
    parler: 'Talk to them',
    attentes: 'Expectations',
    freins: 'Barriers',
    habitudes: 'Habits',
    vocabulaire: 'Vocabulary',
    suitAussi: 'Also follows',
    consommation: 'Consumption',
    formatPrefere: 'preferred format',
    sonMoment: 'preferred time',
    partage: 'Shares on: {x}',
    univers: 'Their world',
    panier: 'Shopping',
    achete: 'Buys:',
    marques: 'Brands:',
    panierMoyen: 'average basket',
    declencheur: 'Trigger: {x}',
    horsEcran: 'Off screen',
  },
  personaDetail: {
    core: 'core',
    partAudience: 'audience share',
    confiance: 'confidence',
    jtbd: 'Job to be done',
    tension: 'Main tension',
    portraitSignal: 'Signal portrait',
    contenu: 'Content - measured on signals',
    vocabulaire: 'Vocabulary',
    chainesSuivies: 'Channels followed',
    infere: 'inferred',
    affinite: 'affinity {n}%',
    comptesSuivis: 'Accounts followed',
    consommation: 'Consumption',
    formatPrefere: 'preferred format',
    fenetre: 'engagement window',
    partageVia: 'Shares via {x}',
    parasocial: 'parasocial signal {n}%',
    moments: 'Moments by platform',
    univers: 'Cultural world',
    jeux: 'Games:',
    musique: 'Music:',
    createurs: 'Adjacent creators:',
    comportement: 'Buying behaviour',
    categories: 'Categories:',
    affinitesMarques: 'Brand affinities:',
    probaMerch: 'merch purchase probability',
    panierEstime: 'estimated average basket',
    declencheur: 'Trigger: {x}',
    canal: 'channel {x}',
    horsEcran: 'Off screen:',
    stretch: 'Stretchability affinities',
    euros: '€{v}',
  },
  ecoute: {
    enCours: 'Observation in progress.',
    questions: {
      penses: 'What do you honestly think of it?',
      avis: 'What would change your mind?',
      avecQui: 'Who do you talk about it with?',
    },
    ecouter: 'Listen across platforms',
    rienDeLisible: 'Nothing usable on the platforms yet.',
    reecouter: 'Listen again',
    quatreR: {
      reach: { libelle: 'Reach', sens: 'How many different people talk about it, and on how many platforms.' },
      resonance: { libelle: 'Resonance', sens: 'The tone of what is said about it: the more positive, the higher the score.' },
      retention: { libelle: 'Retention', sens: 'People who come back to talk about it, message after message: loyalty.' },
      relevance: { libelle: 'Relevance', sens: 'The trajectory: whether the score rises or falls from one period to the next.' },
    },
  },
  moments: {
    titre: 'Moment',
    matin: 'Morning',
    midi: 'Lunchtime',
    trajet: 'Commute',
    soiree: 'Evening',
    tard: 'Late night',
    weekendMatin: 'Weekend morning',
    weekendSoir: 'Weekend evening',
    libre: 'Custom',
    placeholder: 'During a Twitch live stream, Friday 11 pm',
  },
}
